import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Image, Dropdown } from "react-bootstrap";
import Logo from "../assets/images/logo.png";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getUserDetailsfromLocal } from "../services/utils";
const StudentHeader = () => {
    const user = JSON.parse(getUserDetailsfromLocal())

    const navigate = useNavigate()
    const logMeout = () => {
        localStorage.clear()
        toast.error("Logged Out")
        navigate('/')
    }
    return (
        <Navbar bg="light" expand="lg" sticky="top" className="main_hdr">
            <Container className="custm_container">
                <Navbar.Brand onClick={() => { navigate('/student-dashboard') }}>
                    <Image src={Logo} fluid className="logo_img" />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto">
                        <Nav.Link onClick={() => { navigate('/student-dashboard') }}>Dashboard</Nav.Link>
                        {/* <Nav.Link href="#schdl">Make Schedule</Nav.Link> */}
                        {/* <Nav.Link onClick={()=>{ navigate('/faq')}} >FAQs</Nav.Link>
                        <Nav.Link  onClick={()=>{ navigate('/about-us')}}>About Us</Nav.Link>
                        <Nav.Link onClick={()=>{ navigate('/contact-us')}} >Contact Us</Nav.Link> */}
                    </Nav>
                    <div className="login_btns ms-3 d-flex align-items-center">
                        <Dropdown className="prfl_drpdwn ms-3" align="end">
                            <Dropdown.Toggle id="dropdown-basic">

                                <p style={{ color: "#164BAF", marginBottom: 0, display: "inline" }}>Hey {user?.first_name}!</p>
                                {/* <Image
                                    src={schl_img}
                                    fluid
                                    className="prfl_img"
                                /> */}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item onClick={() => { navigate('/student-profile/home') }} >
                                    Profile
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => { navigate('/change-password/pwsd') }}>
                                    Change Password
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => { logMeout() }}>Logout</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default StudentHeader;
